import dayjs from 'dayjs';
import { isNil } from 'lodash';

import { SHORT_MONTH_DAY_YEAR_FORMAT } from 'constants/date';
import { formatDate as formatDateOnly } from 'utils/date';

import {
  CLIENT_PROTECTION_EFFECTIVE_PREFIX,
  CLIENT_PROTECTION_REPORT_SUBJECT,
  CLIENT_PROTECTION_UPDATED_PREFIX,
} from './clientProtection.constants';

const formatTimestampLabel = (prefix, value) =>
  isNil(value) ? null : `${prefix} ${dayjs(value).format(SHORT_MONTH_DAY_YEAR_FORMAT)}`;

// effectiveDate is a calendar date (no time-of-day meaning), so it is formatted
// without a timezone shift — a backend ISO datetime like `...T00:00:00Z` must not
// roll back a day in negative-offset timezones.
const formatCalendarDateLabel = (prefix, value) =>
  isNil(value) ? null : `${prefix} ${formatDateOnly(value, SHORT_MONTH_DAY_YEAR_FORMAT)}`;

const getReportHref = email =>
  isNil(email) || email === ''
    ? null
    : `mailto:${email}?subject=${encodeURIComponent(CLIENT_PROTECTION_REPORT_SUBJECT)}`;

/**
 * Maps the broker client-protection endpoint into the zone display shape. Returns
 * null when the response is missing or carries no policy body, so the reducer
 * holds its empty state and the homepage hides the zone instead of showing an
 * empty shell. The body is rendered as plain text downstream (no HTML injection).
 * @param {object|null} data - { body, effectiveDate, reportChannelEmail, updatedAt }
 * @returns {object|null}
 */
export const mapCommandCenterClientProtection = data => {
  if (isNil(data) || isNil(data.body) || data.body === '') {
    return null;
  }

  return {
    body: data.body,
    effectiveLabel: formatCalendarDateLabel(CLIENT_PROTECTION_EFFECTIVE_PREFIX, data.effectiveDate),
    updatedLabel: formatTimestampLabel(CLIENT_PROTECTION_UPDATED_PREFIX, data.updatedAt),
    reportChannelEmail: data.reportChannelEmail ?? null,
    reportHref: getReportHref(data.reportChannelEmail),
  };
};
